<div
  class="form-group align-self-end {{ settings.class }} checkbox-container"
  *ngIf="settings"
>
  <label for="{{ settings.fieldName | titlecase }}">
    {{ settings.label }}
    <span
      *ngIf="required && !disabled && !settings.disableAsterisk"
      class="text-danger required-asterisk-sign"
      >*</span
    >
  </label>
  <div
    [ngClass]="
      (settings.type === 'checkbox-horizontal'
        ? 'checkbox-radio-container direction-horizontal'
        : 'checkbox-radio-container') +
      ' ' +
      settings.customInputClass
    "
  >
    <ng-container *ngFor="let option of options; let optionIndex = index">
      <div class="form-check" *ngIf="!option.hide">
        <input
          class="form-check-input"
          type="checkbox"
          name="{{ settings.fieldName }}f-checkboxbtn{{ option.id }}"
          id="{{ settings.fieldName }}f-checkboxbtn{{ option.id }}-{{
            optionIndex
          }}"
          value="{{ option.id }}"
          [(ngModel)]="option.selected"
          [checked]="isChecked(option)"
          [disabled]="disabled"
          [required]="required"
          (change)="onCheckboxChange(option)"
        />
        <label
          class="form-check-label"
          [ngClass]="{
            'boxes-right': checkboxLayoutRight,
            'item-selected': highlighOnSelected && option.selected
          }"
          for="{{ settings.fieldName }}f-checkboxbtn{{ option.id }}-{{
            optionIndex
          }}"
        >
          {{ option.value }}
        </label>
      </div>
    </ng-container>
  </div>
</div>
